import React, { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import merge from 'lodash/merge'
import PropTypes from 'prop-types'

import * as deviceManagementActions from 'domain/DeviceManagement/actions'
import * as navbarActions from 'domain/Navbar/actions'
import paths from 'constants/paths'
import { selectors } from 'domain'
import withLayout from 'components/layout'

import DeviceManagement from './DeviceManagement'

const DeviceManagementContainer = ({
  devices,
  registerDevice,
  registerDeviceError,
  registeringDevice,
  requestDevices,
  requestingDevices,
  requestShipOptions,
  shipOptions,
  requestingShipOptions,
  searchQuery,
  setDeviceSearchQuery,
  setRegisterDeviceError,
  setSelectedNavbarItem,
}) => {
  useEffect(() => {
    setSelectedNavbarItem(paths.deviceManagement)
  }, [setSelectedNavbarItem])

  useEffect(() => {
    requestDevices()
  }, [requestDevices])

  // Request ship options once when the page loads so drawers can reuse them
  useEffect(() => {
    if (requestShipOptions) {
      requestShipOptions()
    }
  }, [requestShipOptions])

  return (
    <DeviceManagement
      devices={devices}
      registerDevice={registerDevice}
      registerDeviceError={registerDeviceError}
      registeringDevice={registeringDevice}
      requestDevices={requestDevices}
      requestShipOptions={requestShipOptions}
      requestingDevices={requestingDevices}
      requestingShipOptions={requestingShipOptions}
      searchQuery={searchQuery}
      setDeviceSearchQuery={setDeviceSearchQuery}
      setRegisterDeviceError={setRegisterDeviceError}
      shipOptions={shipOptions}
    />
  )
}

DeviceManagementContainer.defaultProps = {
  devices: [],
  registerDeviceError: null,
  searchQuery: '',
}

DeviceManagementContainer.propTypes = {
  devices: PropTypes.array,
  registerDevice: PropTypes.func.isRequired,
  registerDeviceError: PropTypes.string,
  registeringDevice: PropTypes.bool.isRequired,
  requestDevices: PropTypes.func.isRequired,
  requestShipOptions: PropTypes.func,
  requestingDevices: PropTypes.bool.isRequired,
  requestingShipOptions: PropTypes.bool,
  searchQuery: PropTypes.string,
  setDeviceSearchQuery: PropTypes.func.isRequired,
  setRegisterDeviceError: PropTypes.func.isRequired,
  setSelectedNavbarItem: PropTypes.func.isRequired,
  shipOptions: PropTypes.array,
}

const mapStateToProps = state => ({
  devices: selectors.devicesSelector(state),
  registerDeviceError: selectors.registerDeviceErrorSelector(state),
  registeringDevice: selectors.registeringDeviceSelector(state),
  requestingDevices: selectors.requestingDevicesSelector(state),
  requestingShipOptions: selectors.requestingShipOptionsSelector(state),
  searchQuery: selectors.deviceSearchQuerySelector(state),
  shipOptions: selectors.shipOptionsSelector(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    merge({}, navbarActions, deviceManagementActions),
    dispatch
  )

export default withLayout(
  connect(mapStateToProps, mapDispatchToProps)(DeviceManagementContainer)
)
